import styled from 'config/theme';

const SearchPlaceholder = styled.div`
  height: ${props => props.theme.header.height};
  border-bottom: ${props => props.theme.header.borderBottom};
`;

export default SearchPlaceholder;
